import useSuspend from '../lib/useSuspend';
import { computed, inject, unref } from 'vue';
import evaluateCondition from './evaluateCondition';
import { storeToRefs } from 'pinia';
import useContent from '../stores/useContent';

export default function useFilterTags() {
  type Tagged = { tag?: Condition };
  const suspend = useSuspend();
  const wordDoc = unref(inject('wordDoc')) as boolean;
  const audioDoc = inject('audioDoc') as boolean;
  const isEditModeActive = inject('isEditModeActive') as Ref<boolean>;
  const { compiled: content } = storeToRefs(useContent());

  const tagDescriptions = computed(() => {
    return content.value['tag-descriptions'] ?? [];
  });

  const includeAllContent =
    audioDoc || evaluateCondition('includeall', suspend.tags);

  return function filterTags(items: Tagged[] = []) {
    function filter(item: Tagged) {
      if (
        includeAllContent ||
        !suspend ||
        !item.tag ||
        (isEditModeActive.value && tagDescriptions.value[item.tag])
      )
        return true;

      return evaluateCondition(item.tag, suspend.tags);
    }

    return items.filter(filter);
  };
}
